import { useCallback } from 'react';
import { Icon } from 'ui';

export const useNotificationIcon = () => {
  // eslint-disable-next-line sonarjs/cognitive-complexity -- Its only switch with icons, no cognitive load
  const getIcon = useCallback(({ iconType, isRead }: { iconType: string; isRead: boolean }) => {
    const type = isRead ? undefined : 'primary';
    const size = 'middle';

    switch (iconType) {
      case 'activity':
        return isRead ? <Icon icon="heartbeat-line" size={size} /> : <Icon color={type} icon="heartbeat" size={size} />;
      case 'calendar':
        return isRead ? (
          <Icon icon="calendar-line" size={size} />
        ) : (
          <Icon color={type} icon="calendar-fill" size={size} />
        );
      case 'comment':
        return isRead ? <Icon icon="chat-1-line" size={size} /> : <Icon color={type} icon="chat-1-fill" size={size} />;
      case 'donation':
      case 'giving':
        return isRead ? (
          <Icon icon="hand-heart-line" size={size} />
        ) : (
          <Icon color={type} icon="hand-heart-fill" size={size} />
        );
      case 'like':
        return isRead ? <Icon icon="heart-line" size={size} /> : <Icon color={type} icon="heart-fill" size={size} />;
      case 'program':
        return isRead ? (
          <Icon icon="mortarboard-line" size={size} />
        ) : (
          <Icon color={type} icon="mortarboard-fill" size={size} />
        );
      case 'video':
        return isRead ? <Icon icon="video-line" size={size} /> : <Icon color={type} icon="video-fill" size={size} />;
      default:
        return isRead ? (
          <Icon icon="notification-line" size={size} />
        ) : (
          <Icon color={type} icon="notification-fill" size={size} />
        );
    }
  }, []);

  return { getIcon };
};
